<script>
import moment from "moment";

export default {
  methods: {
    formatDateTime: function(value) {
      return moment(String(value)).format("MM/DD/YYYY hh:mm");
    }
  }
};
</script>
